import React, { useEffect, useState } from "react";
import {
  fetch_styles,
  delete_styles,
} from "../../../services/admin/styles";
import ItemListingTable, {
  getTableUpdateCallback,
} from "../common/ItemListingTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import ShopPopup from "./ShopPopup";
import { notify_promise } from "../../../services/utils/toasts";
import ListingPageControls from "../common/ListingPageControls";

const StylesListingPage = ({ pageState, setPageState }) => {
  const [styles, setStyles] = useState([]);

  const [selectedStyle, setSelectedStyle] = useState(undefined);

  const [fields, setFields] = useState([]);
  const [pagination, setPagination] = useState({});

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("search"));
  const [latestSearchQuery, setLatestSearchQuery] = useState(
    searchParams.get("search")
  );

  const [perPage, setPerPage] = useState(10);

  const apiCall = [
    fetch_styles,
    { page: 0, search: search ? search : "", perPage: perPage },
  ];

  const handleDelete = (id) => {
    notify_promise(
      new Promise((resolve, reject) => {
        delete_styles([id])
          .then((res) => {
            setStyles((prevStyles) => {
              return prevStyles.filter((p) => {
                return p.id !== id;
              });
            });
            resolve(res);
          })
          .catch(reject);
      })
    );
  };

  useEffect(() => {
    updateTableInfo(1);
  }, [latestSearchQuery, perPage]);

  useEffect(() => {
    setSearch(searchParams.get("search"));
  }, [searchParams.get("search")]);

  useEffect(() => {
    setLatestSearchQuery(search);
  }, [search]);

  const updateTableInfo = getTableUpdateCallback({
    apiCall: apiCall,
    dataSetter: setStyles,
    paginationSetter: setPagination,
    fieldSetter: setFields,
    buttons: [
      {
        template: "edit",
        getRedirectURL: (id) => {
          return "/admin/element-styles/edit/:id";
        },
      },
      {
        template: "delete",
        onClick: (id) => {
          handleDelete(id);
        },
      },
    ],
  });

  return (
    <div className="page-content py-3 px-4 bg-lightgray">
      <ShopPopup shop={selectedStyle} />

      <ListingPageControls
        type="styles"
        resultType="styles"
        addOnly={true}
        setSearch={setSearchParams}
        noExport={true}
        addNewLink="/admin/element-styles/add"
      />

      <ItemListingTable
        fields={fields}
        data={styles}
        pagination={pagination}
        updateTableInfo={updateTableInfo}
        setPerPage={setPerPage}
        perPage={perPage}
      />
    </div>
  );
};

export default StylesListingPage;
